import { render, staticRenderFns } from "./ReservationDayBoard.vue?vue&type=template&id=57f3bced&scoped=true&"
import script from "./ReservationDayBoard.vue?vue&type=script&lang=js&"
export * from "./ReservationDayBoard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDayBoard.vue?vue&type=style&index=0&id=57f3bced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f3bced",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VIcon,VSkeletonLoader,VSnackbar,VTab,VTabItem,VTabs,VTabsItems})
